export default __webpack_public_path__ + "static/media/landscaping_Irrigation.d84ca48d.svg";